import React from 'react'
// import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
// import { Button } from 'antd'
import { Helmet } from 'react-helmet'
import { getTheme, recordCountlyEvent } from 'utils'
import applePayRequest from 'utils/applePayRequest'
import _ from 'lodash'

const merCaps = {
  DC: ['supports3DS', 'supportsDebit'],
  CC: ['supports3DS', 'supportsCredit'],
  GC: ['supports3DS', 'supportsCredit', 'supportsDebit'],
  DEFAULT: ['supports3DS'],
}

export default class ApplePay extends React.Component {
  // constructor (props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }

  handleClick = () => {
    const { payInfo, payMethod, validateURL, submit, orderLabel } = this.props
    const mc = _.get(payMethod, 'payMethodExtension.debitCredit', 'DEFAULT')
    applePayRequest.creatSession({
      data: {
        countryCode: 'AE',
        currencyCode: _.get(payInfo, 'payAmount.currency'),
        total: { label: orderLabel, amount: _.get(payInfo, 'payAmount.amount') },
        merchantCapabilities: merCaps[mc],
      },
      validateURL: validateURL,
      payMethodShortNo: _.get(payMethod, 'payMethodShortNo'),
      submit: submit,
    })
  }

  componentDidMount = () => {
    const { orderNo } = this.props
    document.getElementById('apple-pay-button').addEventListener('click', () => {
      recordCountlyEvent({
        page_name: 'cashier',
        element_name: 'pay',
        event_name: 'submit',
        biz_tags: {
          trade_voucher_no: orderNo,
          token: this.props.orderToken,
          pay_method: 'apple_pay',
        },
      })
      this.handleClick()
    })
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <script src='https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js' />
          <style>
            {`
              apple-pay-button {
                --apple-pay-button-width: calc(100% - 2px);
                --apple-pay-button-height: 46px;
                --apple-pay-button-border-radius: 8px;
              }
            `}
          </style>
        </Helmet>
        <apple-pay-button id='apple-pay-button' buttonstyle={getTheme() === 'dark' ? 'black' : 'white-outline'} type='plain' locale='en-US' />
      </React.Fragment>
    )
  }
}
